import { nameOf } from '../shared/common';
import { QueryParser } from '../shared/QueryParser';

export class StoreLocatorQuery {
  storeName?: string;
  storeTypes?: Array<string> = [];
  brands?: Array<string> = [];
  hideContact?: boolean;
  hideFilter?: boolean;
  hideSidebar?: boolean;
  initialZoom?: number;
}

export const STORE_NAME = nameOf<StoreLocatorQuery>('storeName');
export const STORE_TYPES = nameOf<StoreLocatorQuery>('storeTypes');
export const BRANDS = nameOf<StoreLocatorQuery>('brands');
export const HIDE_CONTACT = nameOf<StoreLocatorQuery>('hideContact');
export const HIDE_FILTER = nameOf<StoreLocatorQuery>('hideFilter');
export const HIDE_SIDEBAR = nameOf<StoreLocatorQuery>('hideSidebar');
export const INITIAL_ZOOM = nameOf<StoreLocatorQuery>('initialZoom');

export class StoreLocatorQueryParser extends QueryParser {
  static toModel(query: Map<string, string>) {
    const queryModel = new StoreLocatorQuery();

    queryModel.brands = QueryParser.getValues(query, BRANDS);
    queryModel.storeName = QueryParser.getValue(query, STORE_NAME);
    queryModel.storeTypes = QueryParser.getValues(query, STORE_TYPES);
    queryModel.hideContact = QueryParser.getValue(query, HIDE_CONTACT) === true.toString();
    queryModel.hideFilter = QueryParser.getValue(query, HIDE_FILTER) === true.toString();
    queryModel.hideSidebar = QueryParser.getValue(query, HIDE_SIDEBAR) === true.toString();
    queryModel.initialZoom = parseInt(QueryParser.getValue(query, INITIAL_ZOOM), 10);

    return queryModel;
  }

  static toQuery(queryModel: StoreLocatorQuery) {
    const query = new Map<string, string>();

    QueryParser.setValues(query, BRANDS, queryModel.brands);
    QueryParser.setValues(query, STORE_TYPES, queryModel.storeTypes);

    return query;
  }
}
